import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMAGE_SRC } from '../../../shared/shared-constants';

@Component({
  selector: 'app-report-button',
  templateUrl: './report-button.component.html',
  styleUrls: ['./report-button.component.scss'],
  standalone: false,
})
export class ReportButtonComponent {
  readonly IMAGES = IMAGE_SRC;
  @Input() buttonText!: string;
  @Input() hasDownloadIcon = false;
  @Input() hasArrowIcon = false;

  @Output() emitButtonClick = new EventEmitter<Event>();
}
